// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/bootstrap-icons/font/bootstrap-icons.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23999%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255%2C255%2C255%2C0.7%29%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.5;
  color: #212529;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

html, body {
  min-height: 100vh;
  min-height: 100dvh;
}

/* 1. Типографика: иерархия без новых шрифтов */
main h1 {
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  margin-bottom: 0;
}
main h5 {
  font-size: 1rem;
  font-weight: 600;
}
main .text-muted,
main .text-secondary {
  font-size: 0.875rem;
}


/* 4. Шапка: аккуратный разделитель, стики на скролле */
.app-header {
  position: sticky;
  top: 0;
  z-index: 1030;
  background-color: #f8f9fa;
}
.app-header .navbar {
  min-height: 60px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.app-header .navbar .container {
  display: flex;
  align-items: center;
}
.app-header .app-navbar-brand {
  color: rgba(0, 0, 0, 0.55);
  transition: color 0.15s ease;
}
.app-header .app-navbar-brand:hover {
  color: rgba(0, 0, 0, 0.9);
}
.app-header .nav-link {
  transition: color 0.15s ease;
}

/* Мобильное меню: открытый список — absolute под шапкой */
@media (max-width: 991.98px) {
  .app-header .navbar {
    position: relative;
  }
  .app-header .navbar-collapse {
   
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1020;
    background-color: #f8f9fa;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    padding:12px 0 24px;
  }

  .app-header .navbar-collapse >div{
    max-width: 720px;
    margin: 0 auto;
    padding:0 12px;
  }
  
  .app-header .navbar-collapse >div:last-child{
    
    padding:12px 12px 0;

  }
  .app-header .navbar-collapse .container {
    flex-direction: column;
    align-items: stretch;
  }

  /* При открытом меню — иконка крестика вместо бургера */
  .app-header.navbar-menu-open .navbar-toggler .navbar-toggler-icon,
  .app-header .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background-size: 0.75em;
  }

  [data-bs-theme="dark"] .app-header .navbar-collapse {
    
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
}

@media (max-width: 767.5px){
  .app-header .navbar-collapse >div{
    max-width: 540px;
  } 
}

/* 5. Формы: плавный фокус */
.form-control:focus,
.form-select:focus {
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

/* 6. Кнопки: лёгкий переход */
.btn {
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

/* 7. Пустые и загрузочные состояния */
main .text-center.text-secondary,
main .text-center.text-muted {
  padding: 1.5rem 0.5rem;
}

/* Helper popover: не вызывать появление скроллбара при наведении */
.popover {
  position: fixed !important;
}

/* CategoryMultiSelect: чекбокс и лейбл на всю ширину */
.category-multiselect-check.form-check {
  display: flex;
  width: 100%;
  gap: 8px;

}
.category-multiselect-check .form-check-label {
  cursor: pointer;
  flex: 1 1;
}

.loader-cnt{
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 99;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  position: relative;
  animation: rotate 1s linear infinite
}
.loader::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 5px solid #484848;
  animation: prixClipFix 2s linear infinite ;
}

@keyframes rotate {
  100%   {transform: rotate(360deg)}
}

@keyframes prixClipFix {
    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
    25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
    75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
    100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
}


main {
  min-height: calc(100vh - 60px);
  min-height: calc(100dvh - 60px);
  display: flex;
}

main .container{
  width: 100%;
  flex: 1 1 auto;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px;
}
main .container > div{
  width: 100%;
}
form{
  max-width: 100%;
}
/* 2–3. Карточки списков: лёгкая тень и hover */
main .row.border.rounded.text-bg-light,
main .row.border.rounded.bg-light {
  transition: box-shadow 0.15s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
main .row.border.rounded.text-bg-light:hover,
main .row.border.rounded.bg-light:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
/* Формы create/edit: ширина, центр, лёгкая тень */
.form-card-col {
  max-width: 100%;
  width: 544px;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

/* ========== Тёмная тема (data-bs-theme="dark") ========== */
[data-bs-theme="dark"] {
  color-scheme: dark;
}

/* Шапка: тёмный фон и светлый текст */
[data-bs-theme="dark"] .app-header {
  background-color: var(--bs-dark) !important;
}
[data-bs-theme="dark"] .app-header .app-navbar.navbar-light.bg-light {
  background-color: var(--bs-dark) !important;
  border-bottom-color: rgba(255, 255, 255, 0.1) !important;
  --bs-navbar-color: rgba(255, 255, 255, 0.85);
  --bs-navbar-hover-color: rgba(255, 255, 255, 1);
  --bs-navbar-active-color: #fff;
}
[data-bs-theme="dark"] .app-header .navbar-collapse {
  background-color: var(--bs-dark) !important;
  border-bottom-color: rgba(255, 255, 255, 0.1) !important;
  
}
[data-bs-theme="dark"] .app-header .navbar-brand,
[data-bs-theme="dark"] .app-header .nav-link {
  color: rgba(255, 255, 255, 0.85) !important;
}
[data-bs-theme="dark"] .app-header .app-navbar-brand {
  color: rgba(255, 255, 255, 0.75) !important;
}
[data-bs-theme="dark"] .app-header .app-navbar-brand:hover {
  color: #fff !important;
}
[data-bs-theme="dark"] .app-header .navbar-brand:hover,
[data-bs-theme="dark"] .app-header .nav-link:hover {
  color: #fff !important;
}
[data-bs-theme="dark"] .app-header .navbar-toggler {
  border-color: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.85);
}
[data-bs-theme="dark"] .app-header .navbar-toggler-icon {
  filter: brightness(0) invert(1);
}
[data-bs-theme="dark"] .app-header.navbar-menu-open .navbar-toggler .navbar-toggler-icon,
[data-bs-theme="dark"] .app-header .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
  filter: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-size: 0.75em;
}
[data-bs-theme="dark"] .app-header .text-muted {
  color: rgba(255, 255, 255, 0.6) !important;
}
[data-bs-theme="dark"] .app-header .link-secondary {
  color: rgba(255, 255, 255, 0.75) !important;
}
[data-bs-theme="dark"] .app-header .link-secondary:hover {
  color: #fff !important;
}

/* CategoryMultiSelect: список в тёмной теме */
[data-bs-theme="dark"] .category-multiselect-list {
  background-color: var(--bs-tertiary-bg) !important;
  border-color: var(--bs-border-color) !important;
}

/* Лоадер в тёмной теме */
[data-bs-theme="dark"] .loader::before {
  border-color: rgba(255, 255, 255, 0.4);
}

/* ---------- Текст: лучшая читаемость в тёмной теме ---------- */
[data-bs-theme="dark"] body,
[data-bs-theme="dark"] main {
  color: var(--bs-body-color);
}
[data-bs-theme="dark"] h1, [data-bs-theme="dark"] h2, [data-bs-theme="dark"] h3,
[data-bs-theme="dark"] h4, [data-bs-theme="dark"] h5, [data-bs-theme="dark"] h6 {
  color: rgba(255, 255, 255, 0.95);
}
[data-bs-theme="dark"] .text-muted {
  color: rgba(255, 255, 255, 0.65) !important;
}
[data-bs-theme="dark"] .text-secondary {
  color: rgba(255, 255, 255, 0.7) !important;
}
[data-bs-theme="dark"] .form-label {
  color: rgba(255, 255, 255, 0.9);
}
[data-bs-theme="dark"] .form-text.text-muted {
  color: rgba(255, 255, 255, 0.6) !important;
}

/* Карточки/блоки с text-bg-light → тёмный фон, светлый текст */
[data-bs-theme="dark"] .text-bg-light {
  background-color: var(--bs-secondary-bg) !important;
  color: var(--bs-body-color) !important;
  border-color: var(--bs-border-color) !important;
}
[data-bs-theme="dark"] .text-bg-light .text-muted {
  color: rgba(255, 255, 255, 0.65) !important;
}
[data-bs-theme="dark"] .text-bg-light h1,
[data-bs-theme="dark"] .text-bg-light h2,
[data-bs-theme="dark"] .text-bg-light h3,
[data-bs-theme="dark"] .text-bg-light h4,
[data-bs-theme="dark"] .text-bg-light h5,
[data-bs-theme="dark"] .text-bg-light h6 {
  color: rgba(255, 255, 255, 0.95);
}

/* Блоки bg-light без text-bg (форма логина, карточки на Home) */
[data-bs-theme="dark"] .bg-light {
  background-color: var(--bs-secondary-bg) !important;
  border-color: var(--bs-border-color) !important;
}
[data-bs-theme="dark"] .bg-light.text-dark,
[data-bs-theme="dark"] .bg-light .text-dark {
  color: rgba(255, 255, 255, 0.95) !important;
}
[data-bs-theme="dark"] .bg-light .text-muted,
[data-bs-theme="dark"] .bg-light small.text-muted {
  color: rgba(255, 255, 255, 0.65) !important;
}
[data-bs-theme="dark"] .bg-light .fw-bold,
[data-bs-theme="dark"] .bg-light h1,
[data-bs-theme="dark"] .bg-light h2,
[data-bs-theme="dark"] .bg-light h3,
[data-bs-theme="dark"] .bg-light h4,
[data-bs-theme="dark"] .bg-light h5,
[data-bs-theme="dark"] .bg-light h6 {
  color: rgba(255, 255, 255, 0.95);
}

/* Карточки списков в тёмной теме: тень мягче */
[data-bs-theme="dark"] main .row.border.rounded.text-bg-light,
[data-bs-theme="dark"] main .row.border.rounded.bg-light {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
[data-bs-theme="dark"] main .row.border.rounded.text-bg-light:hover,
[data-bs-theme="dark"] main .row.border.rounded.bg-light:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
[data-bs-theme="dark"] .form-card-col {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

/* Пагинация: текст счётчика */
[data-bs-theme="dark"] .pagination .text-muted {
  color: rgba(255, 255, 255, 0.65) !important;
}
[data-bs-theme="dark"] .pagination .page-link {
  color: var(--bs-body-color);
}
[data-bs-theme="dark"] .pagination .page-item.active .page-link {
  color: #fff;
}

/* Карточки (Card): заголовок и текст */
[data-bs-theme="dark"] .card-title {
  color: rgba(255, 255, 255, 0.95);
}

/* Алерты в main: текст читаемый */
[data-bs-theme="dark"] .alert {
  border-color: currentColor;
}

/* Кнопка outline-primary в тёмной теме: белый текст, синяя граница */
[data-bs-theme="dark"] .btn-outline-primary {
  color: #fff;
  border-color: var(--bs-primary);
}
[data-bs-theme="dark"] .btn-outline-primary:hover {
  color: #fff;
  background-color: var(--bs-primary);
  border-color: var(--bs-primary);
}

/* Кнопка переключателя темы в шапке: контраст в тёмной теме */
[data-bs-theme="dark"] .app-header .btn-outline-secondary {
  color: rgba(255, 255, 255, 0.85);
  border-color: rgba(255, 255, 255, 0.4);
}
[data-bs-theme="dark"] .app-header .btn-outline-secondary:hover {
  color: var(--bs-dark);
  background-color: rgba(255, 255, 255, 0.9);
  border-color: rgba(255, 255, 255, 0.9);
}

/* Select в шапке (язык) */
[data-bs-theme="dark"] .app-header .form-select {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.95);
}
[data-bs-theme="dark"] .app-header .form-select option {
  background-color: var(--bs-dark);
  color: #fff;
}

/* Ссылки в контенте: контраст в тёмной теме */
[data-bs-theme="dark"] main a:not(.btn):not(.nav-link) {
  color: var(--bs-primary-text-emphasis);
}
[data-bs-theme="dark"] main a:not(.btn):not(.nav-link):hover {
  color: var(--bs-primary-border-subtle);
}

/* Ссылки внутри карточек .text-bg-light / .bg-light */
[data-bs-theme="dark"] .text-bg-light a:not(.btn),
[data-bs-theme="dark"] .bg-light a:not(.btn) {
  color: rgba(255, 255, 255, 0.9);
}
[data-bs-theme="dark"] .text-bg-light a:not(.btn):hover,
[data-bs-theme="dark"] .bg-light a:not(.btn):hover {
  color: #fff;
}

/* Превью шаблона: на мобилках 250px, от sm и выше 320px */
.template-preview-media {
  height: auto;
  object-fit: contain;
  width: fit-content;

}
@media (min-width: 576px) {
  .template-preview-media {
    height: 250px;
  }
}

@media (min-width: 768px) {
  .template-preview-media {
    height: 340px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;;;AAGA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;;AAEA,0DAA0D;AAC1D;EACE;IACE,kBAAkB;EACpB;EACA;;IAEE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,4CAA4C;IAC5C,0CAA0C;IAC1C,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;;EAErB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA,uDAAuD;EACvD;;IAEE,oEAAsV;IACtV,uBAAuB;EACzB;;EAEA;;IAEE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,4BAA4B;AAC5B;;EAEE,0DAA0D;AAC5D;;AAEA,8BAA8B;AAC9B;EACE,kFAAkF;AACpF;;AAEA,sCAAsC;AACtC;;EAEE,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,0BAA0B;AAC5B;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,WAAW;EACX,QAAQ;;AAEV;AACA;EACE,eAAe;EACf,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,QAAQ;EACR,SAAS;EACT,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;AACF;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,QAAQ,yBAAyB;AACnC;;AAEA;IACI,MAAM,8CAA8C;IACpD,MAAM,0DAA0D;IAChE,MAAM,mEAAmE;IACzE,MAAM,6DAA6D;IACnE,MAAM,0DAA0D;AACpE;;;AAGA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA,+CAA+C;AAC/C;;EAEE,iCAAiC;EACjC,yCAAyC;AAC3C;AACA;;EAEE,yCAAyC;AAC3C;AACA,kDAAkD;AAClD;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,wDAAwD;EACxD,4CAA4C;EAC5C,+CAA+C;EAC/C,8BAA8B;AAChC;AACA;EACE,2CAA2C;EAC3C,wDAAwD;;AAE1D;AACA;;EAEE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,YAAY;EACZ,oEAA2W;EAC3W,uBAAuB;AACzB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,kDAAkD;EAClD,+CAA+C;AACjD;;AAEA,yBAAyB;AACzB;EACE,sCAAsC;AACxC;;AAEA,iEAAiE;AACjE;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,0CAA0C;AAC5C;;AAEA,+DAA+D;AAC/D;EACE,mDAAmD;EACnD,sCAAsC;EACtC,+CAA+C;AACjD;AACA;EACE,2CAA2C;AAC7C;AACA;;;;;;EAME,gCAAgC;AAClC;;AAEA,gEAAgE;AAChE;EACE,mDAAmD;EACnD,+CAA+C;AACjD;AACA;;EAEE,2CAA2C;AAC7C;AACA;;EAEE,2CAA2C;AAC7C;AACA;;;;;;;EAOE,gCAAgC;AAClC;;AAEA,+CAA+C;AAC/C;;EAEE,wCAAwC;AAC1C;AACA;;EAEE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,2CAA2C;AAC7C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,0BAA0B;AAC5B;;AAEA,qEAAqE;AACrE;EACE,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA,8DAA8D;AAC9D;EACE,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;;AAEA,sDAAsD;AACtD;;EAEE,+BAA+B;AACjC;AACA;;EAEE,WAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;;AAEpB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["@import 'bootstrap/dist/css/bootstrap.min.css';\n@import 'bootstrap-icons/font/bootstrap-icons.css';\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 1.5;\n  color: #212529;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nhtml, body {\n  min-height: 100vh;\n  min-height: 100dvh;\n}\n\n/* 1. Типографика: иерархия без новых шрифтов */\nmain h1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  margin-bottom: 0;\n}\nmain h5 {\n  font-size: 1rem;\n  font-weight: 600;\n}\nmain .text-muted,\nmain .text-secondary {\n  font-size: 0.875rem;\n}\n\n\n/* 4. Шапка: аккуратный разделитель, стики на скролле */\n.app-header {\n  position: sticky;\n  top: 0;\n  z-index: 1030;\n  background-color: #f8f9fa;\n}\n.app-header .navbar {\n  min-height: 60px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n.app-header .navbar .container {\n  display: flex;\n  align-items: center;\n}\n.app-header .app-navbar-brand {\n  color: rgba(0, 0, 0, 0.55);\n  transition: color 0.15s ease;\n}\n.app-header .app-navbar-brand:hover {\n  color: rgba(0, 0, 0, 0.9);\n}\n.app-header .nav-link {\n  transition: color 0.15s ease;\n}\n\n/* Мобильное меню: открытый список — absolute под шапкой */\n@media (max-width: 991.98px) {\n  .app-header .navbar {\n    position: relative;\n  }\n  .app-header .navbar-collapse {\n   \n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 1020;\n    background-color: #f8f9fa;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    padding:12px 0 24px;\n  }\n\n  .app-header .navbar-collapse >div{\n    max-width: 720px;\n    margin: 0 auto;\n    padding:0 12px;\n  }\n  \n  .app-header .navbar-collapse >div:last-child{\n    \n    padding:12px 12px 0;\n\n  }\n  .app-header .navbar-collapse .container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  /* При открытом меню — иконка крестика вместо бургера */\n  .app-header.navbar-menu-open .navbar-toggler .navbar-toggler-icon,\n  .app-header .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23999'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") !important;\n    background-size: 0.75em;\n  }\n\n  [data-bs-theme=\"dark\"] .app-header .navbar-collapse {\n    \n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  }\n}\n\n@media (max-width: 767.5px){\n  .app-header .navbar-collapse >div{\n    max-width: 540px;\n  } \n}\n\n/* 5. Формы: плавный фокус */\n.form-control:focus,\n.form-select:focus {\n  transition: box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n/* 6. Кнопки: лёгкий переход */\n.btn {\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n/* 7. Пустые и загрузочные состояния */\nmain .text-center.text-secondary,\nmain .text-center.text-muted {\n  padding: 1.5rem 0.5rem;\n}\n\n/* Helper popover: не вызывать появление скроллбара при наведении */\n.popover {\n  position: fixed !important;\n}\n\n/* CategoryMultiSelect: чекбокс и лейбл на всю ширину */\n.category-multiselect-check.form-check {\n  display: flex;\n  width: 100%;\n  gap: 8px;\n\n}\n.category-multiselect-check .form-check-label {\n  cursor: pointer;\n  flex: 1;\n}\n\n.loader-cnt{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  z-index: 99;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%,-50%);\n}\n.loader {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite\n}\n.loader::before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  border: 5px solid #484848;\n  animation: prixClipFix 2s linear infinite ;\n}\n\n@keyframes rotate {\n  100%   {transform: rotate(360deg)}\n}\n\n@keyframes prixClipFix {\n    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}\n    25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}\n    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}\n    75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}\n    100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}\n}\n\n\nmain {\n  min-height: calc(100vh - 60px);\n  min-height: calc(100dvh - 60px);\n  display: flex;\n}\n\nmain .container{\n  width: 100%;\n  flex: 1 1 auto;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 10px;\n}\nmain .container > div{\n  width: 100%;\n}\nform{\n  max-width: 100%;\n}\n/* 2–3. Карточки списков: лёгкая тень и hover */\nmain .row.border.rounded.text-bg-light,\nmain .row.border.rounded.bg-light {\n  transition: box-shadow 0.15s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\nmain .row.border.rounded.text-bg-light:hover,\nmain .row.border.rounded.bg-light:hover {\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n/* Формы create/edit: ширина, центр, лёгкая тень */\n.form-card-col {\n  max-width: 100%;\n  width: 544px;\n  margin-left: auto;\n  margin-right: auto;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n/* ========== Тёмная тема (data-bs-theme=\"dark\") ========== */\n[data-bs-theme=\"dark\"] {\n  color-scheme: dark;\n}\n\n/* Шапка: тёмный фон и светлый текст */\n[data-bs-theme=\"dark\"] .app-header {\n  background-color: var(--bs-dark) !important;\n}\n[data-bs-theme=\"dark\"] .app-header .app-navbar.navbar-light.bg-light {\n  background-color: var(--bs-dark) !important;\n  border-bottom-color: rgba(255, 255, 255, 0.1) !important;\n  --bs-navbar-color: rgba(255, 255, 255, 0.85);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 1);\n  --bs-navbar-active-color: #fff;\n}\n[data-bs-theme=\"dark\"] .app-header .navbar-collapse {\n  background-color: var(--bs-dark) !important;\n  border-bottom-color: rgba(255, 255, 255, 0.1) !important;\n  \n}\n[data-bs-theme=\"dark\"] .app-header .navbar-brand,\n[data-bs-theme=\"dark\"] .app-header .nav-link {\n  color: rgba(255, 255, 255, 0.85) !important;\n}\n[data-bs-theme=\"dark\"] .app-header .app-navbar-brand {\n  color: rgba(255, 255, 255, 0.75) !important;\n}\n[data-bs-theme=\"dark\"] .app-header .app-navbar-brand:hover {\n  color: #fff !important;\n}\n[data-bs-theme=\"dark\"] .app-header .navbar-brand:hover,\n[data-bs-theme=\"dark\"] .app-header .nav-link:hover {\n  color: #fff !important;\n}\n[data-bs-theme=\"dark\"] .app-header .navbar-toggler {\n  border-color: rgba(255, 255, 255, 0.3);\n  color: rgba(255, 255, 255, 0.85);\n}\n[data-bs-theme=\"dark\"] .app-header .navbar-toggler-icon {\n  filter: brightness(0) invert(1);\n}\n[data-bs-theme=\"dark\"] .app-header.navbar-menu-open .navbar-toggler .navbar-toggler-icon,\n[data-bs-theme=\"dark\"] .app-header .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon {\n  filter: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgba(255%2C255%2C255%2C0.7)'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") !important;\n  background-size: 0.75em;\n}\n[data-bs-theme=\"dark\"] .app-header .text-muted {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\n[data-bs-theme=\"dark\"] .app-header .link-secondary {\n  color: rgba(255, 255, 255, 0.75) !important;\n}\n[data-bs-theme=\"dark\"] .app-header .link-secondary:hover {\n  color: #fff !important;\n}\n\n/* CategoryMultiSelect: список в тёмной теме */\n[data-bs-theme=\"dark\"] .category-multiselect-list {\n  background-color: var(--bs-tertiary-bg) !important;\n  border-color: var(--bs-border-color) !important;\n}\n\n/* Лоадер в тёмной теме */\n[data-bs-theme=\"dark\"] .loader::before {\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n/* ---------- Текст: лучшая читаемость в тёмной теме ---------- */\n[data-bs-theme=\"dark\"] body,\n[data-bs-theme=\"dark\"] main {\n  color: var(--bs-body-color);\n}\n[data-bs-theme=\"dark\"] h1, [data-bs-theme=\"dark\"] h2, [data-bs-theme=\"dark\"] h3,\n[data-bs-theme=\"dark\"] h4, [data-bs-theme=\"dark\"] h5, [data-bs-theme=\"dark\"] h6 {\n  color: rgba(255, 255, 255, 0.95);\n}\n[data-bs-theme=\"dark\"] .text-muted {\n  color: rgba(255, 255, 255, 0.65) !important;\n}\n[data-bs-theme=\"dark\"] .text-secondary {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n[data-bs-theme=\"dark\"] .form-label {\n  color: rgba(255, 255, 255, 0.9);\n}\n[data-bs-theme=\"dark\"] .form-text.text-muted {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\n\n/* Карточки/блоки с text-bg-light → тёмный фон, светлый текст */\n[data-bs-theme=\"dark\"] .text-bg-light {\n  background-color: var(--bs-secondary-bg) !important;\n  color: var(--bs-body-color) !important;\n  border-color: var(--bs-border-color) !important;\n}\n[data-bs-theme=\"dark\"] .text-bg-light .text-muted {\n  color: rgba(255, 255, 255, 0.65) !important;\n}\n[data-bs-theme=\"dark\"] .text-bg-light h1,\n[data-bs-theme=\"dark\"] .text-bg-light h2,\n[data-bs-theme=\"dark\"] .text-bg-light h3,\n[data-bs-theme=\"dark\"] .text-bg-light h4,\n[data-bs-theme=\"dark\"] .text-bg-light h5,\n[data-bs-theme=\"dark\"] .text-bg-light h6 {\n  color: rgba(255, 255, 255, 0.95);\n}\n\n/* Блоки bg-light без text-bg (форма логина, карточки на Home) */\n[data-bs-theme=\"dark\"] .bg-light {\n  background-color: var(--bs-secondary-bg) !important;\n  border-color: var(--bs-border-color) !important;\n}\n[data-bs-theme=\"dark\"] .bg-light.text-dark,\n[data-bs-theme=\"dark\"] .bg-light .text-dark {\n  color: rgba(255, 255, 255, 0.95) !important;\n}\n[data-bs-theme=\"dark\"] .bg-light .text-muted,\n[data-bs-theme=\"dark\"] .bg-light small.text-muted {\n  color: rgba(255, 255, 255, 0.65) !important;\n}\n[data-bs-theme=\"dark\"] .bg-light .fw-bold,\n[data-bs-theme=\"dark\"] .bg-light h1,\n[data-bs-theme=\"dark\"] .bg-light h2,\n[data-bs-theme=\"dark\"] .bg-light h3,\n[data-bs-theme=\"dark\"] .bg-light h4,\n[data-bs-theme=\"dark\"] .bg-light h5,\n[data-bs-theme=\"dark\"] .bg-light h6 {\n  color: rgba(255, 255, 255, 0.95);\n}\n\n/* Карточки списков в тёмной теме: тень мягче */\n[data-bs-theme=\"dark\"] main .row.border.rounded.text-bg-light,\n[data-bs-theme=\"dark\"] main .row.border.rounded.bg-light {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n[data-bs-theme=\"dark\"] main .row.border.rounded.text-bg-light:hover,\n[data-bs-theme=\"dark\"] main .row.border.rounded.bg-light:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n[data-bs-theme=\"dark\"] .form-card-col {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n/* Пагинация: текст счётчика */\n[data-bs-theme=\"dark\"] .pagination .text-muted {\n  color: rgba(255, 255, 255, 0.65) !important;\n}\n[data-bs-theme=\"dark\"] .pagination .page-link {\n  color: var(--bs-body-color);\n}\n[data-bs-theme=\"dark\"] .pagination .page-item.active .page-link {\n  color: #fff;\n}\n\n/* Карточки (Card): заголовок и текст */\n[data-bs-theme=\"dark\"] .card-title {\n  color: rgba(255, 255, 255, 0.95);\n}\n\n/* Алерты в main: текст читаемый */\n[data-bs-theme=\"dark\"] .alert {\n  border-color: currentColor;\n}\n\n/* Кнопка outline-primary в тёмной теме: белый текст, синяя граница */\n[data-bs-theme=\"dark\"] .btn-outline-primary {\n  color: #fff;\n  border-color: var(--bs-primary);\n}\n[data-bs-theme=\"dark\"] .btn-outline-primary:hover {\n  color: #fff;\n  background-color: var(--bs-primary);\n  border-color: var(--bs-primary);\n}\n\n/* Кнопка переключателя темы в шапке: контраст в тёмной теме */\n[data-bs-theme=\"dark\"] .app-header .btn-outline-secondary {\n  color: rgba(255, 255, 255, 0.85);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n[data-bs-theme=\"dark\"] .app-header .btn-outline-secondary:hover {\n  color: var(--bs-dark);\n  background-color: rgba(255, 255, 255, 0.9);\n  border-color: rgba(255, 255, 255, 0.9);\n}\n\n/* Select в шапке (язык) */\n[data-bs-theme=\"dark\"] .app-header .form-select {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: rgba(255, 255, 255, 0.95);\n}\n[data-bs-theme=\"dark\"] .app-header .form-select option {\n  background-color: var(--bs-dark);\n  color: #fff;\n}\n\n/* Ссылки в контенте: контраст в тёмной теме */\n[data-bs-theme=\"dark\"] main a:not(.btn):not(.nav-link) {\n  color: var(--bs-primary-text-emphasis);\n}\n[data-bs-theme=\"dark\"] main a:not(.btn):not(.nav-link):hover {\n  color: var(--bs-primary-border-subtle);\n}\n\n/* Ссылки внутри карточек .text-bg-light / .bg-light */\n[data-bs-theme=\"dark\"] .text-bg-light a:not(.btn),\n[data-bs-theme=\"dark\"] .bg-light a:not(.btn) {\n  color: rgba(255, 255, 255, 0.9);\n}\n[data-bs-theme=\"dark\"] .text-bg-light a:not(.btn):hover,\n[data-bs-theme=\"dark\"] .bg-light a:not(.btn):hover {\n  color: #fff;\n}\n\n/* Превью шаблона: на мобилках 250px, от sm и выше 320px */\n.template-preview-media {\n  height: auto;\n  object-fit: contain;\n  width: fit-content;\n\n}\n@media (min-width: 576px) {\n  .template-preview-media {\n    height: 250px;\n  }\n}\n\n@media (min-width: 768px) {\n  .template-preview-media {\n    height: 340px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
